import SurfaceDetailsModalButton from '@components/product/SurfaceDetailsModalButton'
import { useUI } from '@components/ui'
import cn from 'clsx'
import { FC, useState } from 'react'

interface props {
  surfaceArea: number
  setSurfaceArea: (area: number) => void
  setNumberOfCoats: (numberOfCoats: string) => void
  prismicContent: any
  selectedSurfaceTitle: (title: string) => void
}

const ProductSurfaceSelection: FC<props> = ({
  surfaceArea,
  setSurfaceArea,
  prismicContent,
  setNumberOfCoats,
  selectedSurfaceTitle,
}) => {
  const { setSelectedSurfaceRequiresPrepCoatUpsell } = useUI()
  const { declarationText, surfaceSelectionTitle, slices } =
    prismicContent || {}
  const [selectedSurfaceIndex, setSelectedSurfaceIndex] = useState(
    surfaceArea > 0
      ? slices.findIndex((s: any) => s.primary.areaRatio === surfaceArea)
      : -1
  )
  return (
    <div className="flex h-full flex-col">
      <div>
        <div className="flex items-center justify-between">
          {surfaceSelectionTitle && (
            <div className="body-1-bold text-ui-dark-grey">
              {surfaceSelectionTitle}
            </div>
          )}
          <button className="mx-auto flex justify-center gap-1.5 outline-none focus:outline-none">
            <SurfaceDetailsModalButton prismicContent={prismicContent} />
          </button>
        </div>
        {slices && (
          <div className="mt-6 md:mt-10">
            {slices.map((surface: any, index: number) => {
              const {
                areaRatio,
                numberOfCoats,
                helperModalTitle,
                requiredPrepCoatUpsell,
                text,
              } = surface.primary
              const selectSurface = () => {
                setSelectedSurfaceIndex(index)
                setSurfaceArea(areaRatio)
                setNumberOfCoats(numberOfCoats)
                setSelectedSurfaceRequiresPrepCoatUpsell(requiredPrepCoatUpsell)
                selectedSurfaceTitle(helperModalTitle)
              }

              return (
                <div key={`surface-${index}`}>
                  {text && (
                    <button
                      className={cn(
                        'body-1 mb-2 w-full rounded-sm border bg-white p-4 text-left text-ui-dark-grey outline-none',
                        {
                          'border-ui-dark-grey bg-ui-light-grey':
                            selectedSurfaceIndex === index,
                          'border-ui-grey-25': selectedSurfaceIndex !== index,
                        }
                      )}
                      onClick={selectSurface}
                    >
                      {text}
                    </button>
                  )}
                </div>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}

export default ProductSurfaceSelection
